import { OpportunitiesHeader as OpportunitiesHeaderDesktop } from "./OpportunitiesHeader.desktop";
import { OpportunitiesHeader as OpportunitiesHeaderMobile } from "./OpportunitiesHeader.mobile";
import { useLayoutType } from "@src/hooks";

export const OpportunitiesHeader = () => {
  const layoutType = useLayoutType();

  return layoutType === "desktop" ? <OpportunitiesHeaderDesktop /> : <OpportunitiesHeaderMobile />;
};
